import api from 'services/api.service';

const getEmbedEditorLink = (templateId) => api.post('/signnow/template/embed-editor', { templateId });

const getLinkForSign = ({ documentId, fieldInviteId }) => api.post(
  '/signnow/link-for-sign',
  { documentId, fieldInviteId },
);

const getDocGroupLinkForSign = ({ documentGroupId, fieldInviteId }) => api.post(
  '/signnow/document-group-link-for-sign',
  { documentGroupId, fieldInviteId },
);

const sendInvite = ({ documentId }) => api.post(
  '/signnow/send-invite',
  { documentId },
);

const sendDocGroupInvite = ({ documentIds }) => api.post(
  '/signnow/send-doc-group-invite',
  { documentIds },
);

export {
  getEmbedEditorLink,
  getLinkForSign,
  getDocGroupLinkForSign,
  sendInvite,
  sendDocGroupInvite,
};
